import React from 'react';
import { Div, DivProps } from '@kizi/core-components';
import { PersonalDataMinimizedWrapper } from './PersonalDataMinimized';
import { Desktop, Mobile } from '../utils/breakpoint';
import { InnerContentWrapper } from './InnerPersonalData/InnerContentWrapper';
import { ComponentDescriptor } from '@kizi/comparator-core';
import { ComparatorType } from '../../src/utils/types';
export interface ExtraProps {
  header?: string | ComponentDescriptor;
  body?: string;
}

export type Page = 'input' | 'overview';
export type Fields = Array<ComponentDescriptor | string>;

export interface PersonalDataProps extends DivProps {
  title: string;
  type: ComparatorType;
  forms: string[];
  formFields: Fields;
  templateFields: Fields;
  mobilePreview: string;
  extra?: ExtraProps;
}

export const PersonalData: React.FC<PersonalDataProps> = React.forwardRef<
  HTMLDivElement,
  PersonalDataProps
>(
  (
    {
      title,
      type,
      forms,
      formFields,
      templateFields,
      mobilePreview,
      extra,
      ...divProps
    },
    ref
  ) => (
    <>
      <Desktop>
        <Div variant="primaryCard" padding={6} ref={ref} {...divProps}>
          <InnerContentWrapper
            title={title}
            formFields={formFields}
            templateFields={templateFields}
            forms={forms}
            extra={extra}
          />
        </Div>
      </Desktop>

      <Mobile>
        <PersonalDataMinimizedWrapper
          {...divProps}
          preview={mobilePreview}
          title={title}
        >
          <InnerContentWrapper
            title={title}
            forms={forms}
            formFields={formFields}
            templateFields={templateFields}
            extra={extra}
          />
        </PersonalDataMinimizedWrapper>
      </Mobile>
    </>
  )
);
